import styled from 'styled-components'
import PropTypes from 'prop-types'

const LearningBadgePathStyled = styled.div`
  &.fill-all {
    background-color: var(--turquoise);
  }
  z-index: 2;
  overflow: hidden;
  position: relative;
  border-radius: 50%;
  background-color: var(--neutral60);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  .grayscale {
    filter: grayscale(100%);
  }
  img {
    width: 22.4px;
    height: 22.4px;
    background: var(--sky);
    background-color: ${({ active }) => (active && 'var(--neutral100)')};
    border-radius: 50%;
    padding: 2.24px;
    border: none;
  }
  @media(min-width: 768px) {
    width: 64px;
    height: 64px;
    /* box-shadow: inset 0 0 0 4px var(--neutral60); */
    /* border-width: 4px; */
    img {
      width: 46px;
      height: 46px;
      padding: 6px
    }
  }
  ${({ progress, progressAngle }) =>
  (progress && progress <= 50 && `
    /* TO REPRESENT FROM 00% TO 50% WE MOVE IT FROM 90deg to 270dec the first gradient */
    background-color: var(--turquoise)!important;
    background-image:
      linear-gradient(${progressAngle}deg, transparent 50%, var(--neutral60) 50%),
      linear-gradient(90deg, var(--neutral60) 50%, transparent 50%)!important;
  `) ||
  (progress && progress > 50 && `
    /* TO REPRESENT FROM 50% TO 100% WE MOVE IT FROM 270deg to 90deg the second gradient */
    background-image:
      linear-gradient(270deg, var(--turquoise) 50%, #ffffff00 50%),
      linear-gradient(${progressAngle}deg, var(--turquoise) 50%, var(--neutral60) 50%)!important;
  `)}
`

function LearningBadgePath({
  src, alt, progress, progressAngle,
}) {
  return (
    <LearningBadgePathStyled progress={progress} progressAngle={progressAngle}>
      <img src={src} alt={alt} width="22.4" height="22.4" className={!progress ? 'grayscale' : ''} loading="lazy" />
    </LearningBadgePathStyled>
  )
}

LearningBadgePath.defaultProps = {
  progress: 0,
  progressAngle: null,
}

LearningBadgePath.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  progress: PropTypes.number,
  progressAngle: PropTypes.number,
}

export default LearningBadgePath
